import image from "../../assets/images/bg-image.png";
import LoginForm from "../../components/forms/loginForm";
import logo from "../../assets/images/FBN-LOG.svg"
import { useLogin } from "../../hooks/Muitation/useLogin"

export default function Login() {
  const { mutate: login, isPending } = useLogin();

  return (


    <div className="md:flex">
      <img src={image} alt="Background" className="md:w-1/3 object-cover h-screen w-full" />
      <div className="w-full p-2 ">
        <div className="hidden md:flex md:justify-end">
        <img src={logo} alt="Logo" className="" />
        </div>
        <div className="flex justify-center items-center h-full ">
          <LoginForm loginFn={login} loading={isPending}/>
        </div>
      </div>
    </div>
  );
}
